import MainAddress from "../..";
import axios from 'axios';
import { GetSerialProgram } from "../../../util/sessionManager";

export async function GetCustomerLocations(){
    try{
        
        
        const response = await axios.post(
            MainAddress+'GPS/ReadCustomerLocation.php',
            {
                serialProgram:GetSerialProgram(),
            }
          )
    
        if(response.data[0].success){
            console.log(response);
            console.log(response.data);
            return {
                success:true,
                data:[
                    ...response.data,
                ]
            };
        }else{
            
            return {
                success:false
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }
}

export async function GetAllPaths(){
    try{
        
        
        const response = await axios.post(
            MainAddress+'GPS/read_allPaths.php',
            {
                serialProgram:GetSerialProgram(),
            }
          )
    
        if(response.data[0].success){
            console.log(response);
            console.log(response.data);
            return {
                success:true,
                data:[
                    ...response.data,
                ]
            };
        }else{
            
            return {
                success:false
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }
}